import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const CollectorAccountForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [collectorOptions, setCollectorOptions] = useState([])

    const [formData, setFormData] = useState({
        collector_id: "",
        name: "",
        number: "",
    })
    const {collector_id, name, number} = formData

    const navigate = useNavigate()

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const loadOptions = async (url, query, setOptions) => {

        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {collector_id, name, number}
        addAccount(payload)
    }
    
    // add account
    const addAccount = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/collector-accounts/', payload)
            if (response.status === 201){
                toast.success('Successfully created')
                navigate('/collector-accounts')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Collector Account Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="collector_id"
                                label="Collector"
                                value={collector_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('collectors', query, setCollectorOptions)}
                                options={collectorOptions}
                                placeholder="Start typing to search..."
                                error={errors.collector_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Account Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>

                        <div className="col-md-4">
                            <InputField
                                placeholder="Account Number"
                                name="number"
                                type="text"
                                label="Number"
                                value={number}
                                onChange={onChange}
                                error={errors.number}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Account" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default CollectorAccountForm